export default "__VITE_ASSET__VmkGBhKD__"